import { isOperatorMcpConnection } from "@dashboardApi/apis/appGroupIdOperatorMcpConnections";

export const isGetAppGroupIdOperatorMcpConnectionsConnectionIdResult = isOperatorMcpConnection;
